module.exports = __webpack_public_path__ + "static/media/Footer-Tablet.5f037cc8.jpg";